import { render, staticRenderFns } from "./verifikasi_pmptsp.vue?vue&type=template&id=66fed123&scoped=true"
import script from "./verifikasi_pmptsp.vue?vue&type=script&lang=js"
export * from "./verifikasi_pmptsp.vue?vue&type=script&lang=js"
import style0 from "./verifikasi_pmptsp.vue?vue&type=style&index=0&id=66fed123&prod&lang=scss"
import style1 from "./verifikasi_pmptsp.vue?vue&type=style&index=1&id=66fed123&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fed123",
  null
  
)

export default component.exports